import gql from 'graphql-tag';

export const SFTP_SETTINGS = gql`
  query SftpSettings($organizationId: String!) {
    sftpSettings(organizationId: $organizationId) {
      host
      port
      username
      inboundDir
      outboundDir
      catalogDir
      catalogPattern
      outboundArchiveDir
      isaSenderQual
      isaSenderId
      isaReceiverQual
      isaReceiverId
      isaVersion
      isaUsage
      isaSubSep
      gsSenderId
      gsReceiverId
      gsVersion
      accountPrefix
      defaultShipToAccount
      billToIdQualifier
      billToAccount
      billToName
      begType
      segmentTerminator
      elementSeparator
      headerRefQualifier
      headerRefId
      headerRefDescription
      hasPassword
      hasPrivateKey
      shipToProfiles {
        code
        name
        account
        addr1
        city
        state
        zip
        isDefault
      }
    }
  }
`;

export const UPSERT_SFTP_SETTINGS = gql`
  mutation UpsertSftpSettings($params: UpsertSFTPSettingsInput!) {
    upsertSFTPSettings(params: $params) {
      host
      port
      username
      begType
      segmentTerminator
      elementSeparator
      billToName
      billToIdQualifier
      billToAccount
      defaultShipToAccount
      headerRefQualifier
      headerRefId
      headerRefDescription
    }
  }
`;
